import React from 'react';
export function SocialProof() {
  const stats = [{
    number: '2.847+',
    label: 'Compradores en Argentina'
  }, {
    number: '4.9★',
    label: 'Calificación Promedio'
  }, {
    number: '$1.800M',
    label: 'Generados por Clientes (ARS)'
  }, {
    number: '98%',
    label: 'Tasa de Satisfacción'
  }];
  return <section className="py-16 px-4" data-id="element-83">
      <div className="max-w-[1200px] mx-auto bg-[#00d4ff]/5 border-2 border-[#00d4ff]/20 rounded-xl p-10 md:p-14 text-center shadow-[0_0_30px_rgba(0,212,255,0.05)]" data-id="element-84">
        <h2 className="text-2xl md:text-3xl font-bold text-[#00d4ff] mb-12 uppercase tracking-wide" data-id="element-85">
          PROBADO POR MILES DE ARGENTINOS
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-86">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center justify-center p-4" data-id="element-87">
              <span className="text-4xl md:text-5xl font-black text-[#00d4ff] mb-3" data-id="element-88">
                {stat.number}
              </span>
              <span className="text-[0.95rem] text-[#e0e0e0]/80 font-medium uppercase tracking-wider" data-id="element-89">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}